import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { SelectOption } from 'common/types/select-option';
import _, { PropsWithChildren } from 'react';

export type AccordionToggleFn = (key: string, expanded: boolean) => void;

interface Props {
  groupId?: string;
  controlId: string;
  headerLabel: string;
  data: SelectOption[] | undefined;
  values: string[] | undefined;
  expanded: boolean | undefined;
  changeValuesFn: (controlId: string, id: string, checked: boolean, groupId?: string) => void;
  toggleExpandFn: AccordionToggleFn;
}

const OptionAccordion = (props: PropsWithChildren<Props>) => {
  const handleAccordionChange = (_: React.ChangeEvent<{}>, isExpanded: boolean) => {
    props.toggleExpandFn(props.controlId, isExpanded);
  };

  const handleCheckChange = async (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setTimeout(() => {
      props.changeValuesFn(props.controlId, event.target.id, checked, props.groupId);
    });
  };

  return (
    <>
      <Grid container>
        <Accordion
          TransitionProps={{ unmountOnExit: true }}
          expanded={props.expanded}
          onChange={handleAccordionChange}
          sx={{ flexGrow: 1 }}
        >
          <AccordionSummary
            sx={{
              '& .MuiSvgIcon-root': {
                color: 'primary.main',
              },
              '& .MuiAccordionSummary-content': {
                marginTop: '8px !important',
                marginBottom: '4px !important',
                '& .Mui-expanded': {
                  marginTop: '8px !important',
                  marginBottom: '4px !important',
                },
              },
              '&.Mui-expanded': {
                minHeight: 42,
              },
              '& .MuiAccordionSummary-expandIconWrapper': {
                position: 'relative',
                top: '2px',
              },
              minHeight: 42,
            }}
            expandIcon={props.expanded ? <RemoveIcon /> : <AddIcon />}
          >
            <>
              <Typography color="primary" fontSize={14}>
                {props.headerLabel}
              </Typography>
            </>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              paddingTop: 0,
              paddingBottom: 1,
              paddingLeft: 3,
            }}
          >
            {props.data?.map(x => (
              <Box key={`${props.groupId ? props.groupId : ''}:${props.controlId}:${x.id}`}>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        padding: 0.5,
                      }}
                      checked={(props.values || []).includes(x.id)}
                      onChange={handleCheckChange}
                      id={x.id}
                    />
                  }
                  label={x.label}
                />
              </Box>
            ))}
            {props.children && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: 0.5,
                }}
              >
                {props.children}
              </Box>
            )}
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export default OptionAccordion;
